// ----------------------------------------------------------------------------
// Component: Main Blog
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts

// Styles
import './_main-blog.scss';

  var canonicalUrl = "{{ canonical_url }}";
  var searchBar = document.getElementById("bloggle--input_search_container");


  var navigationLinks = document.getElementsByClassName('bloggle--nav-item');
  if (navigationLinks.length > 0) {
    for (let i = 0; i < navigationLinks.length ; i++) {
        let href = navigationLinks[i].getAttribute("href");
        let isHrefInCanonical = canonicalUrl.indexOf(href) > -1;
        function isHrefLastSegment(string, target) {
            return string.substring(string.length - target.length) === target;
          }
      if (isHrefInCanonical && href && isHrefLastSegment(canonicalUrl, href)) {
        navigationLinks[i].classList.add("bloggle--active");
      } else {
        navigationLinks[i].classList.remove("bloggle--active");
      }
    }
  }

  window.addEventListener('input', function (e) {
    var id = e.target.getAttribute("id");
    var resultContainer = document.getElementById("bloggle--search_results");

    if (id && id == "bloggle--input_search") {
      var searchValue = e.target.value;
      if (searchValue.length > 1) {
        var request = new XMLHttpRequest();
        request.responseType = 'json'
        const suggestUrl = "https://" + window.location.hostname + (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/" ) + "search/suggest.json?q=" + searchValue + "&resources[type]=article";
        request.open('GET', suggestUrl, true);
        request.onload = function (e) {
          if (this.status == 200) {
            var articles = this.response.resources.results.articles;
            if (articles.length > 0) {
              let resultsHtml = "";
              for (let i = 0; i < articles.length; i++) {
                resultsHtml = resultsHtml + '<div class="bloggle--search_result"><a class="bloggle--search_result_link" href="' + articles[i].url + '">' + articles[i].title + '</a></div>'
              }
              resultContainer.innerHTML = resultsHtml;
            } else {
              resultContainer.innerHTML = "";
            }
          }
        }
        request.send();
      } else {
        resultContainer.innerHTML = "";
      }
    }
  });